module.exports = __webpack_public_path__ + "static/pexels-andrea-piacquadio-3777578-1ec87914b71561c1e001d616b9568056.jpg";